import { render, staticRenderFns } from "./AlertsG.vue?vue&type=template&id=49629cb0&scoped=true"
import script from "./AlertsG.vue?vue&type=script&lang=js"
export * from "./AlertsG.vue?vue&type=script&lang=js"
import style0 from "./AlertsG.vue?vue&type=style&index=0&id=49629cb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49629cb0",
  null
  
)

export default component.exports